import React from "react";
import {CommonDropdown} from "root/s360components/ReactHookForm/ui/CommonDropdown";
import {UserTypes} from "root/globals";

//UserTypes in globals has no parent entry
const USER_TYPE_PARENT = 24;

export const LJ_APP_USAGE_USER_TYPES = [
    {value: USER_TYPE_PARENT, label: 'Parent'},
    {value: UserTypes.USER_TYPE_TEACHER, label: 'Teacher'},
];

const DropdownLJAppUsageUserType = ({control, name, onChange, rules, placeholder, isSearchable, isClearable, readOnly}) =>
{
    return (
        <CommonDropdown items={LJ_APP_USAGE_USER_TYPES} control={control} name={name} rules={rules}
                        onChange={onChange} readOnly={readOnly}
                        isSearchable={isSearchable} isClearable={isClearable}
                        placeholder={placeholder}/>
    )
}

export default DropdownLJAppUsageUserType;
